import * as React from 'react';
import cx from 'classnames';

// Hooks
import { useResponsiveLayout } from '@shopee-user/layout-responsive';
import { useBackgroundColor } from '@shopee-user/background-color-container';

// Context
import { RouteLoadingContext } from '@shopee/route-loading-context';

// Components
import { Navbar, PageLoading } from '@shopee-user/business-customization-ui';
import { ResponsiveContainer } from '@shopee-user/layout-responsive';

// Constants
import { Layout } from '@shopee-user/layout-responsive';
import { config } from '@shopee-user/business-customization-logic';

// Styles
import styles from './style.scss';

type Props = {
  className?: string;
  enableBackgroundColor?: boolean;
  shouldHideNavbarInDesktop?: boolean;
  shouldHideBack?: boolean;
  backgroundColorMobile?: string;
  backgroundColorDesktop?: string;
  title?: string;
  rightContent?: React.ReactNode;
  onClickBack?: (event: React.SyntheticEvent) => void;
};

export default function PageGeneric({
  className,
  enableBackgroundColor = true,
  shouldHideNavbarInDesktop,
  shouldHideBack,
  backgroundColorMobile = config.Background.ColorMobile,
  backgroundColorDesktop = config.Background.ColorDesktop,
  title,
  rightContent,
  onClickBack = () => undefined,
}: Props) {
  const { layout } = useResponsiveLayout();
  useBackgroundColor({
    mobile: backgroundColorMobile,
    desktop: backgroundColorDesktop,
    enableBackgroundColor,
  });

  return (
    <ResponsiveContainer className={cx(className, styles.container)}>
      {layout === Layout.Desktop && !shouldHideNavbarInDesktop && (
        <Navbar
          title={title}
          rightContent={rightContent}
          onClickBack={onClickBack}
          shouldHideBack={shouldHideBack}
        />
      )}
      <RouteLoadingContext.Consumer>
        {({ showLoadingPlaceholder }) => {
          if (showLoadingPlaceholder) {
            return <PageLoading />;
          } else {
            return null;
          }
        }}
      </RouteLoadingContext.Consumer>
    </ResponsiveContainer>
  );
}
